import { CombinedAuthRoleGuard } from './services/combinedAuthRole.guard';
import { IsTopicGuard } from './services/isTopic.guard';
import { InviteToTeamComponent } from './settings/inviteToTeam.component';
import { ExistingChangesGuard } from './services/existingChanges.guard';
import { EditTopicSettingsComponent } from './topics/editTopicSettings.component';
import { ThinSignupStartComponent } from './ui/thinSignupStart.component';
import { RoleGuard } from './services/role.guard';
import { EditTopicContentItemsTabComponent } from './topics/editTopicContentItemsTab.component';
import { DefaultRouter } from './digestReader/defaultRouter.component';
import { SearchPane } from './home/searchPane.component';
import { RecommendedPane } from './home/recommendedPane.component';
import { BookmarkedPane } from './home/bookmarkedPane.component';
import { RecentPane } from './home/recentPane.component';
import { ReaderComponent } from './digestReader/reader.component';
import { TopicPaneComponent } from './reading/topicPane.component';
import { BriefingComponent } from './briefings/briefings.component';
import { BriefingShareComponent } from './briefings/briefingShare.component';
import { BriefingListComponent } from './briefings/briefingList.component';
import { RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { RegisterComponent } from './ui';
import { DigestSchedulerComponent } from './digestSchedule';
import { BriefingOnlyGuard, UnAuthGuard, UncategorizedGuard, SubscribeGuard, SelfSignupEnabledGuard } from './services';
import { BriefingSubscribeComponent } from './briefings/briefingSubscribe.component';
import { BriefingSubscribePreviewComponent } from './briefings/briefingSubscribePreview.component';
import { BriefingUnsubscribeComponent } from './briefings/briefingUnsubscribe.component';
import { MenuItemGuard } from './services/menuItem.guard';
import { TopicsComponent } from './topics/topics.component';
import { StartCreateTopicComponent } from './topics/startCreateTopic.component';
import { EditTopicContentComponent } from './topics/editTopicContent.component';
import { EditTopicContentSourcesTabComponent } from './topics/editTopicContentSourcesTab.component';
import { EditTopicContentFiltersTabComponent } from './topics/editTopicContentFiltersTab.component';
import { EditTopicComponent } from './topics/editTopic.component';
import { EditTopicContentAddSourcesComponent } from './topics/editTopicContentAddSources.component';
import { ThinSignupComponent } from './ui/thinSignup.component';
import { ThinSignupCompleteComponent } from './ui/thinSignupComplete.component';
import { EditTopicPeopleComponent } from './topics/editTopicPeople.component';
import { InviteToTopicComponent } from './topics/inviteToTopic.component';
import { TopicBuilderComponent } from './topics/topicBuilder.component';
import { BrowseSearchPane } from './browse/browseSearchPane.component';
import { StartersCreateTopicComponent } from './topics/startersCreateTopic.component';
import { AdminComponent } from './settings/admin.component';
import { UserListComponent } from './users/userList.component';
import { SubscriptionPlanComponent } from './settings/subscriptionPlan.component';
import { CombinedAuthAdminGuard } from './services/combinedAuthAdmin.guard';
import { ProfileComponent } from './settings/profile.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordPaneComponent } from './login/ResetPasswordPane.component';
import { BrowseMyTopicsPane } from './browse/browseMyTopicsPane.component';
import { BrowseNewTopicsPane } from './browse/browseNewTopicsPane.component';
import { BrowseAllTeamTopicsPane } from './browse/browseAllTeamTopicsPane.component';
import { BrowseRootComponent } from './browse/browseRoot.component';
import { BrowseCategoryPaneComponent } from './browse/browseCategoryPane.component';
import { UnauthTenantResolver } from './resolvers/unauthTenant.resolver';
import { FullTaxonomyResolver } from './resolvers/fullTaxonomy.resolver';
import { TrimmedPublishedTaxonomyResolver } from './resolvers/trimmedPublishedTaxonomy.resolver';
import { BrowseAllCatalogTopicsPaneComponent } from './browse/browseAllCatalogTopicsPane.component';
import { BrowseCatalogPane } from './browse/browseCatalogPane.component';
import { BrowseCatalogCategoryPane } from './browse/browseCatalogCategoryPane.component';
import { BrowseCatalogCategoryTopicsPane } from './browse/browseCatalogCategoryTopicsPane.component';
import { BrowseTeamPaneComponent } from './browse/browseTeamPane.component';
import { BrowseAllMyTopicsPaneComponent } from './browse/browseAllMyTopicsPane.component';
import { BrowseAllNewTopicsPaneComponent } from './browse/browseAllNewTopicsPane.component';
import { CatalogTopicGuard } from './services/catalogTopic.guard';
import { ManageBriefingsListPaneComponent } from './settings/manageBriefingsListPane.component';
import { ManageBriefingsComponent } from './briefings/manageBriefings.component';
import { EditBriefingPaneComponent } from './settings/editBriefingPane.component';
import { CreateBriefingPaneComponent } from './settings/createBriefingPane.component';
import { PartnerComponent } from './partner/partner.component';
import { SitesComponent } from './partner/sites.component';
import { SitesListComponent } from './partner/sitesList.component';
import { SiteDetailsComponent } from './partner/siteDetails.component';
import { CreateSiteComponent } from './partner/createSite.component';
import { ProductCatalogsComponent } from './partner/productCatalogs.component';
import { PartnerRoleGuard } from './services/partnerRole.guard';
import { SourceManagerComponent } from './settings/sourceManagement.component';
import { IsSourceGuard } from './services/isSource.guard';
import { StreamListComponent } from './settings/streamList.component';
import { SourceAggregationComponent } from './settings/sourceAggregation.component';
import { SourceTopicsComponent } from './settings/sourceTopics.component';
import { StartCreateSourceComponent } from './settings/startCreateSource.component';
import { CreateSourceRootComponent } from './settings/createSourceRoot.component';
import { CreateSourceComponent } from './settings/createSource.component';
import { AccountComponent } from './settings/account.component';
import { GroupManagerComponent } from './groups/groupManager.component';
import { GroupListComponent } from './groups/groupList.component';
import { GroupCreateComponent } from './groups/groupCreate.component';
import { GroupEditComponent } from './groups/groupEdit.component';
import { EditTopicGroupsComponent } from './topics/editTopicGroups.component';
import { UserManagementComponent } from './users/userManagement.component';
import { UserEditComponent } from './users/userEdit.component';
import { AuthGuard } from './services/auth.guard';
import { BrowseGroupsPaneComponent } from './browse/browseGroupsPane.component';
import { BrowseGroupsListComponent } from './browse/browsGroupsList.component';
import { BrowseGroupDetailsComponent } from './browse/browseGroupDetails.component';
import { MostReadPaneComponent } from './home/mostReadPane.component';
import { MostLikedPaneComponent } from './home/mostLikedPane.component';
import { InviteToGroupComponent } from './browse/inviteToGroup.component';
import { BrowseGroupComponent } from './browse/browseGroup.component';
import { JoinGroupComponent } from './browse/joinGroup.component';
import { EditTopicContentItemsTabContainerComponent } from './topics/editTopicContentItemsTabContainer.component';
import { TrialExpiredAdminGuard } from './services/trialExpiredAdmin.guard';
import { TenantSuspendedNonAdminGuard } from './services/tenantSuspendedNonAdmin.guard';
import { UnsubscribeComponent } from './account/unsubscribe.component';
import { UnsubscribeGuard } from './services/unsubscribe.guard';
import { UserSubscriptionComponent } from './settings/userSubscription.component';
import { TrialExpiredIndividualGuard } from './services/trialExpiredIndividual.guard';
import { PublicSubscribeGuard } from './services/publicSubscribe.guard';
import { TagManagerComponent } from './tags/tagManager.component';
import { TagListComponent } from './tags/tagList.component';
import { TagEditComponent } from './tags/tagEdit.component';
import { SearchRouteComponent } from './digestReader/searchRoute.component';
import { UserCreateComponent } from './users/userCreate.component';
import { AuthenticateComponent } from './ui/authenticate.component';
import { PublicAuthGuard } from './services/publicAuth.guard';
import { PublicUnauthGuard } from './services/publicUnauth.guard';
import { BrowseFeaturedTopicsPane } from './browse/browseFeaturedTopicsPane.component';
import { BrowseHomeComponent } from './browse/browseHome.component';
import { FeaturedTenantGuard } from './services/featuredTenant.guard';
import { CatalogListComponent } from './settings/catalogList.component';
import { CatalogManagerGuard } from './services/catalogManager.guard';
import { CatalogEditComponent } from './settings/catalogEdit.component';
import { CatalogEditStreamsComponent } from './settings/catalogEditStreams.component';
import { CatalogAddSourcesComponent } from './settings/catalogAddSources.component';
import { CategoryManagementComponent } from './settings/categoryManagement.component';
import { SharedSourceListComponent } from './settings/sharedSourceList.component';
import { SharedTopicListComponent } from './settings/sharedTopicList.component';
import { SharedTagListComponent } from './settings/sharedTagList.component';
import { SharedTagEditComponent } from './settings/sharedTagEdit.component';
import { PersonalBriefingsManagerComponent } from './settings/personalBriefingsManager.component';

export const routes: ModuleWithProviders = RouterModule.forRoot([
    {
        path: 'digest', component: ReaderComponent, canActivate: [AuthGuard, BriefingOnlyGuard, TrialExpiredAdminGuard, TrialExpiredIndividualGuard],
        children: [
            { path: '', pathMatch: 'full', redirectTo: '/digest/recent' },
            
            { path: 'categories/:categoryId/topics/:topicId', canActivate: [PublicSubscribeGuard, UncategorizedGuard, TenantSuspendedNonAdminGuard], children: [ { path: '**', component: TopicPaneComponent } ]},

            { path: 'recent', canActivate: [MenuItemGuard], children: [{ path: '**', component: RecentPane }]},

            { path: 'mostread', canActivate: [MenuItemGuard, TenantSuspendedNonAdminGuard], children: [{ path: '**', component: MostReadPaneComponent }]},

            { path: 'mostliked', canActivate: [MenuItemGuard, TenantSuspendedNonAdminGuard], children: [{ path: '**', component: MostLikedPaneComponent }]},

            { path: 'bookmarked', canActivate: [MenuItemGuard, TenantSuspendedNonAdminGuard], children: [{ path: '**', component: BookmarkedPane }]},

            { path: 'recommended', canActivate: [MenuItemGuard, TenantSuspendedNonAdminGuard], children: [{ path: '**', component: RecommendedPane }]},

        ],
        resolve: {
            tenant: UnauthTenantResolver,
            taxonomy: FullTaxonomyResolver
        }
    },
    {
        path: 'search', component: SearchRouteComponent, canActivate: [AuthGuard, BriefingOnlyGuard, TrialExpiredAdminGuard, TenantSuspendedNonAdminGuard, TrialExpiredIndividualGuard],
        children: [
            { path: '**', component: SearchPane }
        ]
    },
    {
        path: 'briefings', component: BriefingComponent, canActivate: [TrialExpiredAdminGuard, TenantSuspendedNonAdminGuard, TrialExpiredIndividualGuard],
        children: [
            { path: '', redirectTo: 'list', pathMatch: 'full' },
            { path: 'list', component: BriefingListComponent, canActivate: [AuthGuard] },
            { path: ':briefingId/share', component: BriefingShareComponent, canActivate: [AuthGuard] },
            { path: ':briefingId/preview', component: BriefingSubscribePreviewComponent },
            { path: ':briefingId/subscribe', component: BriefingSubscribeComponent, canActivate: [SubscribeGuard] },
            { path: ':briefingId/unsubscribe/:userId', component: BriefingUnsubscribeComponent }
        ]
    },
    {
        path: 'topics', component: TopicsComponent, canActivate: [TrialExpiredAdminGuard, TenantSuspendedNonAdminGuard, TrialExpiredIndividualGuard],
        children: [
            { path: '', redirectTo: 'create', pathMatch: 'full' },
            { path: 'create', component: StartCreateTopicComponent, canActivate: [CombinedAuthRoleGuard], data: { roles: ['CREATE_STREAM'] } }, 
            { path: 'starters', component: StartersCreateTopicComponent, canActivate: [CombinedAuthRoleGuard], data: { roles: ['CREATE_STREAM'] } },
            { path: 'builder', component: TopicBuilderComponent, canActivate: [CombinedAuthRoleGuard], canDeactivate: [ExistingChangesGuard], data: { roles: ['CREATE_STREAM'] } },
            { path: ':topicId', component: EditTopicComponent, canActivate: [AuthGuard],
              children: [
                { path: '', redirectTo: 'content', pathMatch: 'full' },
                { path: 'content', component: EditTopicContentComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] },
                    children: [
                        { path: '', redirectTo: 'items', pathMatch: 'full' },
                        { path: 'items', component: EditTopicContentItemsTabContainerComponent, 
                            children: [
                                { path: '', redirectTo: 'list', pathMatch: 'full'},
                                { path: 'list', children: [ { path: '**', component: EditTopicContentItemsTabComponent } ]},                                
                            ] 
                        },
                        { path: 'sources', component: EditTopicContentSourcesTabComponent },
                        { path: 'filters', component: EditTopicContentFiltersTabComponent, canDeactivate: [ExistingChangesGuard] },
                        { path: 'addSources', component: EditTopicContentAddSourcesComponent },
                    ]
                },
                { path: 'people', component: EditTopicPeopleComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                { path: 'groups', component: EditTopicGroupsComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                { path: 'settings', component: EditTopicSettingsComponent, canDeactivate: [ExistingChangesGuard], canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                { path: 'invite', component: InviteToTopicComponent, data: { noNavBar: true } }
              ]  
            } 
        ]
    },
    {
        path: 'browse', component: BrowseRootComponent,
        canActivate: [AuthGuard, TenantSuspendedNonAdminGuard, TrialExpiredAdminGuard, TrialExpiredIndividualGuard],
        children: [
            { path: '', redirectTo: 'featured', pathMatch: 'full'},
            { path: 'home', component: BrowseHomeComponent }, 
            { path: 'search', component: BrowseSearchPane },
            { path: 'categories/:categoryId',
                children: [
                    {   path: '', component: BrowseCategoryPaneComponent },
                    {   
                        path: 'new', children: [ 
                            { path: '', component: BrowseCategoryPaneComponent, data: { isNew: true } },
                            { 
                                path: 'topics/:topicId', canActivate: [PublicSubscribeGuard, UncategorizedGuard], 
                                children: [ { path: '**', component: TopicPaneComponent } ]
                            },
                        ] 
                    }
                ] 
            },
            { path: 'catalog/:catalogId', component: BrowseCatalogPane,
                children: [
                    { path: '', component: BrowseAllCatalogTopicsPaneComponent },
                    { path: 'topics/:topicId', canActivate: [PublicSubscribeGuard, UncategorizedGuard], 
                      children: [ { path: '**', component: TopicPaneComponent } ]},
                    {   path: 'categories/:categoryId', 
                        component: BrowseCatalogCategoryPane,
                        children: [
                            {   path: '', component: BrowseCatalogCategoryTopicsPane },
                            {   path: 'new', 
                                children: [
                                    {
                                        path: '', component: BrowseCatalogCategoryTopicsPane, data: { isNew: true },
                                    },
                                    { 
                                        path: 'topics/:topicId', canActivate: [PublicSubscribeGuard, UncategorizedGuard], 
                                        children: [ { path: '**', component: TopicPaneComponent } ]
                                    },
                                ]
                            },
                            { path: 'topics/:topicId', canActivate: [PublicSubscribeGuard, UncategorizedGuard], 
                              children: [ { path: '**', component: TopicPaneComponent } ]},
                        ],
                    },
                    { path: 'new', component: BrowseNewTopicsPane,
                        children: [
                            { path: "", component: BrowseAllNewTopicsPaneComponent },
                            { path: 'topics/:topicId', 
                            children: [ { path: '**', component: TopicPaneComponent } ]},
                        ]
                    }
                ]
            },
            { path: 'mine', component: BrowseMyTopicsPane,
                children: [
                    { path: "", component: BrowseAllMyTopicsPaneComponent },
                    { path: 'topics/:topicId', 
                      children: [ { path: '**', component: TopicPaneComponent } ]},
                ]
            },
            { path: 'groups', component: BrowseGroupsPaneComponent, 
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'list', component: BrowseGroupsListComponent },
                    { path: ':groupId', component: BrowseGroupComponent, children: [
                        { path: '', redirectTo: 'details', pathMatch: 'full' },
                        { path: 'details', component: BrowseGroupDetailsComponent },
                        { path: 'invite', component: InviteToGroupComponent },
                        { path: 'join', component: JoinGroupComponent }
                    ]}
                ] 
            },
            { path: 'featured', canActivate: [FeaturedTenantGuard],
                children: [
                    { path: "", component: BrowseFeaturedTopicsPane },
                    { path: 'topics/:topicId', canActivate: [PublicSubscribeGuard], 
                    children: [ { path: '**', component: TopicPaneComponent, data: { isShortItems: true } } ]},
                ]

            },
            { path: 'team', component: BrowseTeamPaneComponent, 
                children: [
                    { path: "", component: BrowseAllTeamTopicsPane },
                    { path: 'topics/:topicId', canActivate: [PublicSubscribeGuard], 
                      children: [ { path: '**', component: TopicPaneComponent, data: { isShortItems: true } } ]},
                    { path: 'new', component: BrowseNewTopicsPane,
                      children: [
                          { path: "", component: BrowseAllNewTopicsPaneComponent },
                          { path: 'topics/:topicId', 
                          children: [ { path: '**', component: TopicPaneComponent } ]},
                      ]
                    },
                ] 
            },
            { path: 'categories/:categoryId/topics/:topicId', canActivate: [UncategorizedGuard, PublicSubscribeGuard], 
                      children: [ { path: '**', component: TopicPaneComponent } ]},
        ],
        resolve: {
            tenant: UnauthTenantResolver,
            taxonomy: TrimmedPublishedTaxonomyResolver
        }
    },
    {
        path: 'settings', component: AdminComponent, canActivate: [TenantSuspendedNonAdminGuard],
        children: [
            { path:'', redirectTo: 'profile', pathMatch: 'full' },
            { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard,TrialExpiredAdminGuard, TrialExpiredIndividualGuard] },
            { path: 'subscription', component: UserSubscriptionComponent },
            { path: 'account', component: AccountComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard], canDeactivate: [ExistingChangesGuard]},
            { path: 'schedule', component: DigestSchedulerComponent, canActivate: [AuthGuard, TrialExpiredAdminGuard, TrialExpiredIndividualGuard] },
            { path: 'invite', component: InviteToTeamComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard] },
            { path: 'personalBriefings', component: PersonalBriefingsManagerComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard] },
            { path: 'members', component: UserManagementComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
              children: [
                { path: '', component: UserListComponent },
                { path: 'create', component: UserCreateComponent },
                { path: ':userId', component: UserEditComponent }
              ] 
            },
            { path: 'briefings', component: ManageBriefingsComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
                children: [
                    { path: '', component: ManageBriefingsListPaneComponent },
                    { path: 'create/:type', component: CreateBriefingPaneComponent, canDeactivate: [ExistingChangesGuard] },
                    { path: ':briefingId', component: EditBriefingPaneComponent, canDeactivate: [ExistingChangesGuard] }
                ] 
            },
            { path: 'subscriptionPlan', component: SubscriptionPlanComponent, canActivate: [CombinedAuthAdminGuard] },
            { path: 'partner', component: PartnerComponent, canActivate: [AuthGuard, PartnerRoleGuard, TrialExpiredAdminGuard], 
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'sites' },
                    { path: 'sites', component: SitesComponent, children: [
                        { path: '', pathMatch: 'full', redirectTo: 'list' },
                        { path: 'list', component: SitesListComponent },                
                        { path: 'create', component: CreateSiteComponent },
                        { path: ':subtenantId', component: SiteDetailsComponent }
                    ]},
                    { path: 'products', component: ProductCatalogsComponent },    
                    { path: 'create', component: CreateSiteComponent }
                ]
            },
            { path: 'categories', component: CategoryManagementComponent, canActivate: [CombinedAuthAdminGuard], canDeactivate: [ExistingChangesGuard] },
            {
                path: 'shared', canActivate: [AuthGuard, CatalogManagerGuard],
                children: [
                    {
                        path: 'catalogs',
                        children: [
                            { path: '', component: CatalogListComponent },
                            { path: ':catalogId', component: CatalogEditComponent, children: [
                                { path: '', pathMatch: 'full', redirectTo: 'streams' },
                                { path: 'streams', children: [
                                    { path: '', pathMatch: 'full', component: CatalogEditStreamsComponent },
                                    { path: 'sources', children: [
                                        { path: ':topicId', component: EditTopicComponent, data: { isSource: true },
                                            children: [
                                                { path: '', redirectTo: 'content', pathMatch: 'full' },
                                                    { path: 'content', canActivate: [/*IsSourceGuard*/ ], 
                                                  children: [ 
                                                    { path: '**', component: EditTopicContentItemsTabComponent, data: { roles: ['CREATE_STREAM'], isSource: true } } ]},
                                                    { path: 'aggregation', component: SourceAggregationComponent },
                                                    { path: 'topics', component: SourceTopicsComponent },
                                                    { 
                                                        path: 'settings', 
                                                        component: EditTopicSettingsComponent, 
                                                        canDeactivate: [ExistingChangesGuard], 
                                                        data: { roles: ['CREATE_STREAM'], isSource: true, isCatalog: true } 
                                                    },
                                        ]}
                                    ]},
                                    { path: 'addSources', component: CatalogAddSourcesComponent },
                                    { path: 'topics', children: [
                                        { path: ':topicId', component: EditTopicComponent, canActivate: [AuthGuard], data: { isCatalog: true },
                                            children: [
                                                { path: '', redirectTo: 'content', pathMatch: 'full' },
                                                { path: 'content', component: EditTopicContentComponent,
                                                    children: [
                                                        { path: '', redirectTo: 'items', pathMatch: 'full' },
                                                        { path: 'items', component: EditTopicContentItemsTabContainerComponent, 
                                                            children: [
                                                                { path: '', redirectTo: 'list', pathMatch: 'full'},
                                                                { path: 'list', children: [ { path: '**', component: EditTopicContentItemsTabComponent } ]},
                                                            ] 
                                                        },
                                                        { path: 'sources', component: EditTopicContentSourcesTabComponent },
                                                        { path: 'filters', component: EditTopicContentFiltersTabComponent, canDeactivate: [ExistingChangesGuard] },
                                                        { path: 'addSources', component: EditTopicContentAddSourcesComponent, data: { isCatalog: true } },
                                                    ]
                                                },
                                                { path: 'settings', component: EditTopicSettingsComponent, canDeactivate: [ExistingChangesGuard], data: { isCatalog: true } }
                                        ]}
                                    ]},
                                ] },
                                { path: 'categories', component: CategoryManagementComponent, canDeactivate: [ExistingChangesGuard], data: { isCatalog: true } }
                            ] }
                        ]
                    },
                    {
                        path: 'topics',
                        children: [
                            { path: '', component: SharedTopicListComponent, pathMatch: 'full' },
                            { path: ':topicId', component: EditTopicComponent, canActivate: [AuthGuard], data: { isCatalog: true },
                                children: [
                                    { path: '', redirectTo: 'content', pathMatch: 'full' },
                                    { path: 'content', component: EditTopicContentComponent,
                                        children: [
                                            { path: '', redirectTo: 'items', pathMatch: 'full' },
                                            { path: 'items', component: EditTopicContentItemsTabContainerComponent, 
                                                children: [
                                                    { path: '', redirectTo: 'list', pathMatch: 'full'},
                                                    { path: 'list', children: [ { path: '**', component: EditTopicContentItemsTabComponent } ]},
                                                ] 
                                            },
                                            { path: 'sources', component: EditTopicContentSourcesTabComponent },
                                            { path: 'filters', component: EditTopicContentFiltersTabComponent, canDeactivate: [ExistingChangesGuard] },
                                            { path: 'addSources', component: EditTopicContentAddSourcesComponent, data: { isCatalog: true } },
                                        ]
                                    },
                                    {
                                        path: 'settings',
                                        component: EditTopicSettingsComponent,
                                        canDeactivate: [ExistingChangesGuard],
                                        data: { isShared: true, hideCategories: true } }
                            ]}
                        ]
                    },
                    {
                        path: 'sources',
                        children: [
                            { path: '', component: SharedSourceListComponent, pathMatch: 'full' },
                            { path: 'create', children: [
                                { path: '', component: StartCreateSourceComponent, pathMatch: 'full', data: { isCatalog: true } },
                                { path: ':sourceType', component: CreateSourceComponent, data: { isCatalog: true } },
                            ] },
                            { path: ':topicId', component: EditTopicComponent, data: { isSource: true },
                                children: [
                                    { path: '', redirectTo: 'content', pathMatch: 'full' },
                                    { path: 'content', 
                                        children: [ 
                                        { path: '**', component: EditTopicContentItemsTabComponent, data: { roles: ['CREATE_STREAM'], isSource: true } } ]},
                                        { path: 'aggregation', component: SourceAggregationComponent },
                                        { path: 'topics', component: SourceTopicsComponent },
                                        { 
                                            path: 'settings', 
                                            component: EditTopicSettingsComponent, 
                                            canDeactivate: [ExistingChangesGuard], 
                                            data: { roles: ['CREATE_STREAM'], isShared: true, isSource: true, hideCategories: true }
                                        },
                            ]},
                        ]
                    },
                    {
                        path: 'tags',
                        children: [
                            { path: '', component: SharedTagListComponent, pathMatch: 'full' },
                            { path: ':tagId', component: SharedTagEditComponent }
                        ]
                    }
                ]
            },
            { path: 'topics', canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
                children: [
                    { path: '', component: StreamListComponent, data: { isTopics: true }},
                    { path: ':topicId', component: EditTopicComponent,
                        children: [
                            { path: '', redirectTo: 'content', pathMatch: 'full' },
                            { path: 'content', component: EditTopicContentComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] },
                                children: [
                                    { path: '', redirectTo: 'items', pathMatch: 'full' },
                                    { path: 'items', component: EditTopicContentItemsTabContainerComponent, 
                                        children: [
                                            { path: '', redirectTo: 'list', pathMatch: 'full'},
                                            { path: 'list', children: [ { path: '**', component: EditTopicContentItemsTabComponent } ]},                                
                                        ] 
                                    },
                                    { path: 'sources', component: EditTopicContentSourcesTabComponent },
                                    { path: 'filters', component: EditTopicContentFiltersTabComponent, canDeactivate: [ExistingChangesGuard] },
                                    { path: 'addSources', component: EditTopicContentAddSourcesComponent },
                                ]
                            },
                            { path: 'people', component: EditTopicPeopleComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                            { path: 'groups', component: EditTopicGroupsComponent, canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                            { path: 'settings', component: EditTopicSettingsComponent, canDeactivate: [ExistingChangesGuard], canActivate: [RoleGuard, IsTopicGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'] } },
                            { path: 'invite', component: InviteToTopicComponent, data: { noNavBar: true } }
                        ]  
                    }
                ]
            },
            { path: 'sources', component: SourceManagerComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
                children:[
                    { path: '', component: StreamListComponent},
                    { path: 'create', component: CreateSourceRootComponent, children: [
                        { path: '', component: StartCreateSourceComponent, pathMatch: 'full' },
                        { path: ':sourceType', component: CreateSourceComponent },
                    ] },
                    { path: ':topicId', component: EditTopicComponent, data: { isSource: true },
                        children: [
                            { path: '', redirectTo: 'content', pathMatch: 'full' },
                            { path: 'content', canActivate: [RoleGuard, IsSourceGuard, CatalogTopicGuard], 
                              children: [ { path: '**', component: EditTopicContentItemsTabComponent, data: { roles: ['CREATE_STREAM'], isSource: true } } ]},
                            { path: 'aggregation', component: SourceAggregationComponent },
                            { path: 'topics', component: SourceTopicsComponent },
                            { path: 'settings', component: EditTopicSettingsComponent, canDeactivate: [ExistingChangesGuard], canActivate: [RoleGuard, IsSourceGuard, CatalogTopicGuard], data: { roles: ['CREATE_STREAM'], isSource: true } },
                        ]  
                    }
              ] 
            },
            { path: 'groups', component: GroupManagerComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
                children:[
                    { path: '', component: GroupListComponent },
                    { path: 'create', component: GroupCreateComponent },
                    { path: ':groupId', component: GroupEditComponent }
                ]
            },
            { path: 'tags', component: TagManagerComponent, canActivate: [CombinedAuthAdminGuard, TrialExpiredAdminGuard],
                children:[
                    { path: '', component: TagListComponent },
                    { path: ':tagId', component: TagEditComponent }
                ]
            }
        ]
    },
    {   path: 'unsubscribe', component: UnsubscribeComponent, canActivate: [UnsubscribeGuard] },
    {   path: 'login', component: LoginComponent, canActivate: [UnAuthGuard, PublicUnauthGuard] },
    {   path: 'register', component: RegisterComponent, canActivate: [UnAuthGuard]  },
    {   path: 'auth', component: AuthenticateComponent, canActivate: [PublicAuthGuard] },
    {   path: 'completesignup', component: RegisterComponent, canActivate: [UnAuthGuard]  },
    {   path: 'signup', component: ThinSignupComponent, canActivate: [SelfSignupEnabledGuard], 
        children: [
            { path: '', component: ThinSignupStartComponent },
            { path: 'confirmation', component: ThinSignupCompleteComponent }
        ]},
    {   path: 'hello', loadChildren: () => import('./hello/hello.module').then(m => m.HelloModule) },
    {   path: 'resetPassword', component: ResetPasswordPaneComponent },
    {   path: '**', component: DefaultRouter}
], { enableTracing: false });
